/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Join_SubtitleInputs */



/**
* | output |
* | --- |
* | "Finish setting up your account with the invitation link" |
*
* @param {Auth_Join_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_join_subtitle = /** @type {((inputs?: Auth_Join_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Join_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beende die Einrichtung deines Kontos mit dem Einladungslink")
	return /** @type {LocalizedString} */ ("Finish setting up your account with the invitation link")
});